<template>
    <div>
       <HeaderTeam header="ลงเวลาการทำงาน" :img_header="header_image" link_back="team"/>
       <MenuTeamAddTimeWorkList/>
       <OutTimeWorkList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/stopwatch.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamAddTimeWorkList from '@/components/menuadmin/team/teamaddtimework/MenuTeamAddTimeWorkList.vue'
import OutTimeWorkList from '@/components/menuadmin/team/teamaddtimework/OutTimeWorkList.vue'
export default {
    name:'outTimeWork',
    components:{
        HeaderTeam,
        MenuTeamAddTimeWorkList,
        OutTimeWorkList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>